// components/modals/app-modals/onboarding/steps/OnboardingNameStep.jsx

import { useTranslation } from 'react-i18next';
import countryOptions from '../../../../../constants/countryOptions';
import languageOptions from '../../../../../constants/languageOptions';

const OnboardingNameStep = ({ formData, onChange }) => {
  const { t } = useTranslation();

  return (
    <>
      <div className="app-modal-step-intro">
        <h3>{t('onboarding_about_you_title', 'About you')}</h3>
        <p className="app-modal-text-muted">
          {t(
            'onboarding_about_you_intro',
            'Tell us a little about yourself.'
          )}
        </p>
      </div>

      <div className="app-modal-section">
        <label className="app-modal-label">
          {t('display_name_label', 'Your name')}
        </label>
        <p className="app-modal-text-muted">
          {t(
            'displayname_intro',
            'This is the name we’ll use to address you across All-Voiced.'
          )}
        </p>
        <input
          type="text"
          name="displayName"
          value={formData.displayName}
          onChange={onChange}
          className="app-input"
        />
      </div>

      <div className="app-modal-section">
        <label className="app-modal-label">
          {t('pronouns_label', 'Pronouns')}
        </label>
        <select
          name="pronoun"
          value={formData.pronoun}
          onChange={onChange}
          className="app-input"
        >
          <option value="">{t('select')}</option>
          <option value="she/her">She/Her</option>
          <option value="he/him">He/Him</option>
          <option value="they/them">They/Them</option>
          <option value="she/they">She / They</option>
          <option value="he/they">He / They</option>
          <option value="other">{t('other')}</option>
          <option value="prefer_not_to_say">{t('prefer_not_to_say')}</option>
        </select>
      </div>

      <div className="app-modal-section">
        <label className="app-modal-label">
          {t('country_of_residence')}
        </label>
        <select
          name="countryOfResidence"
          value={formData.countryOfResidence}
          onChange={onChange}
          className="app-input"
        >
          <option value="">{t('select')}</option>
          {countryOptions.map(country => (
            <option key={country.value} value={country.value}>
              {country.label}
            </option>
          ))}
        </select>
      </div>

      <div className="app-modal-section">
        <label className="app-modal-label">
          {t('primary_communication_language')}
        </label>
        <select
          name="communicationLanguage"
          value={formData.communicationLanguage}
          onChange={onChange}
          className="app-input"
        >
          <option value="">{t('select')}</option>
          {languageOptions.map(language => (
            <option key={language.value} value={language.value}>
              {language.label}
            </option>
          ))}
        </select>
      </div>
    </>
  );
};

export default OnboardingNameStep;
